//
import { RFormFields } from '@/components/reusable_components/next'

//
import SlCustomerModel from '@/models/Sale/SlCustomer'
import SlCustomerBranchOfficesModel from '@/models/Sale/SlCustomerBranchOffices'
import SlDetailSaleCreditNoteHeaders from '@/views/Sale/SlSaleCreditNote/SlDetailSaleCreditNoteHeaders'

//
export default RFormFields
	.from([
		{
			name: 'number',
			type: 'text-field',
			props: {
				label: 'Folio',
			},
		},
		{
			name: 'sl_customer_rut',
			type: 'text-field',
			props: {
				label: 'Rut',
			},
		},
		{
			name: 'sl_customer_id',
			type: 'autocomplete-model',
			props: {
				itemText: 'alias_name',
				itemValue: 'id',
				label: 'Cliente',
				model: SlCustomerModel,
				noDataText: 'Sin clientes.',
				noObject: true,
				//paramSearch: 'search',
			},
		},
		{
			name: 'sl_customer_branch_offices_id',
			type: 'autocomplete-model',
			props: {
				itemText: 'address',
				itemValue: 'id',
				label: 'Sucursal',
				model: SlCustomerBranchOfficesModel,
				noDataText: 'Sin sucursales.',
				noObject: true,
				paramSearch: 'address',
			},
		},
		{
			name: 'sl_detail_sale_credit_notes',
			type: 'table-field',
			flex: {
				xs12:true
			},
			props: {
				headers: SlDetailSaleCreditNoteHeaders,
				toolbarTitle: 'Productos incluidos',
				readonly: true,
			},
		},
		{
			name: 'accounting_date',
			type: 'text-field',
			props: {
				label: 'Fecha contable',
				readonly: true,
			},
		},
		{
			name: 'accounting_date',
			type: 'text-field',
			props: {
				label: 'Tipo de referencia',
				readonly: true,
			},
		},
		{
			name: 'accounting_date',
			type: 'text-field',
			props: {
				label: 'Folio de referencia',
				readonly: true,
			},
		},
		{
			name: 'emission_date',
			type: 'text-field',
			props: {
				label: 'Fecha emision',
				readonly: true,
			},
		},
		{
			name: 'net_total',
			type: 'currency-field',
			props: {
				label: 'Neto',
				readonly: true,
			},
		},
		{
			name: 'iva',
			type: 'currency-field',
			props: {
				label: 'IVA',
				readonly: true,
			},
		},
		{
			name: 'total',
			type: 'currency-field',
			props: {
				label: 'Total',
				readonly: true,
			},
		},
	])
